import "bootstrap-icons/font/bootstrap-icons.css";
import React, { useRef, useState } from 'react';
import { Dropdown, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import '../css/Sidebar.css';
import { ReactComponent as ZmpgSvg } from '../svg/zmpg.svg';
import { LanguageToggle } from './LanguageToogle';
import { useTranslation } from 'react-i18next';

const Sidebar = ({ onSidebarDisplayChange, userName, companyName }) => {
    const { t } = useTranslation();
    const [toggleSidebar, setToggleSidebar] = useState(true);
    const refToToggleDropdownButton = useRef(null);

    const showHideSidebar = () => {
        onSidebarDisplayChange();
        setToggleSidebar(!toggleSidebar);
    };

    const showHideDropdown = () => {
        refToToggleDropdownButton.current?.click();
    };
    const fetchTranslations = async (lang = 'pl-PL') => {
        try {
            const response = await fetch(`/locales/${lang}.json`);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const translations = await response.json();
        } catch (error) {
        }
    };
    fetchTranslations();
    return (
        <aside className={`app-sidebar ${toggleSidebar ? "show" : "hide"}`}>
            <Nav variant="pills" className="flex-column">
                <div className="aside-logo">
                    <ZmpgSvg />
                </div>
                <ul>
                    <li>
                        <LinkContainer to="/">
                            <Nav.Link className="link-dark text-nowrap" eventKey="1">
                                <i className="bi bi-house-door"></i>
                                <span>{t('layout.sidebar.home')}</span>
                            </Nav.Link>
                        </LinkContainer>
                    </li>
                    <li>
                        <LinkContainer to="/transports">
                            <Nav.Link className="link-dark text-nowrap" eventKey="2">
                                <i className="bi bi-card-checklist"></i>
                                <span>{t('layout.sidebar.transports')}</span>
                            </Nav.Link>
                        </LinkContainer>
                    </li>
                    <li>
                        <LinkContainer to="/drivers">
                            <Nav.Link className="link-dark text-nowrap" eventKey="5">
                                <i className="bi bi-person-circle"></i>
                                <span>{t('layout.sidebar.drivers')}</span>
                            </Nav.Link>
                        </LinkContainer>
                    </li>
                    <li>
                        <LinkContainer to="/cars">
                            <Nav.Link className="link-dark text-nowrap" eventKey="4">
                                <i className="bi bi-truck"></i>
                                <span>{t('layout.sidebar.cars')}</span>
                            </Nav.Link>
                        </LinkContainer>
                    </li>
                    <li>
                        <LinkContainer to="/semitrailers">
                            <Nav.Link className="link-dark text-nowrap" eventKey="7">
                                <i className="bi bi-boxes"></i>
                                <span>{t('layout.sidebar.semitrailers')}</span>
                            </Nav.Link>
                        </LinkContainer>
                    </li>
                </ul>
            </Nav>
            <div className="buttons">
                <LanguageToggle />

                <Dropdown className="position-relative">
                    <div className="user-btn" onClick={showHideDropdown}>
                        <i className="bi bi-person-lines-fill"></i>
                        <span>{t('layout.sidebar.user')}</span>
                    </div>
                    <Dropdown.Toggle
                        className="position-absolute top-0 end-0 invisible pb-1 m-0 border-0"
                        ref={refToToggleDropdownButton}
                    />
                    <Dropdown.Menu className="p-0 user-nav">
                        <Dropdown.Header>{userName}</Dropdown.Header>
                        <Dropdown.Item className="dropdownItem" href="/changepassword">
                            <i className="bi bi-shield-lock-fill"></i>
                            <span>{t('layout.sidebar.changepassword')}</span>
                        </Dropdown.Item>
                        <Dropdown.Item className="dropdownItem" href="/authentication/logout">
                            <i className="bi bi-box-arrow-left"></i>
                            <span>{t('layout.sidebar.logout')}</span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <div className="btn-collapse" onClick={showHideSidebar}>
                    <i className={`bi ${toggleSidebar ? "bi-justify" : "bi-text-left"}`}></i>
                    <span>{t('layout.sidebar.rollMenu')}</span>
                </div>
            </div>
        </aside>
    );
};

export default Sidebar;
